var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 351 213"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#error_svg__a)",
  d: "m212.336 139.611 1.803-14.422 9.914-5.858 1.352 1.802 4.056 4.056c1.953.902 6.941 2.885 11.267 3.606 5.408.901 13.069-.901 17.125-2.704 3.245-1.442 8.863-5.108 11.267-6.76h7.211l5.858-1.352 3.606 12.168 7.21 16.225 4.056 9.464-43.264 8.563-1.352-1.352-1.802-13.07-1.803-9.464-.451 3.155-1.352 7.211-3.154 9.464-2.704 7.211-20.731-4.507-14.421-5.408 4.056-9.014z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#error_svg__b)",
  d: "M290.301 60.29c-.36-7.57-2.553-15.473-3.605-18.477l4.056 2.253c1.953 1.953 6.219 6.94 7.661 11.267 1.803 5.408 2.704 10.817 3.155 16.675.451 5.86-.901 15.324-1.803 20.281-.901 4.958-5.408 14.873-6.76 16.676-1.081 1.442-5.858 5.408-8.112 7.211-1.802 1.051-6.039 3.244-8.562 3.605-2.524.361-5.559-.151-6.76-.451l3.605-4.056c2.704-2.704 9.103-10.726 13.069-21.182 4.958-13.07 4.507-24.337 4.056-33.801"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#error_svg__c)",
  d: "m155.552 49.023 3.605 7.662 28.392.45 38.758-27.942c-.151-1.952-.631-6.4-1.352-8.563-.902-2.704-1.803-4.056-4.056-7.661-1.803-2.885-5.559-5.108-7.211-5.86-1.953-1.05-7.301-3.244-13.069-3.605-7.211-.45-8.112 1.352-10.366 2.704-1.802 1.082-2.553 3.155-2.704 4.057-.601.15-2.343.54-4.506.9-2.704.452-4.056 1.804-5.408 3.156-1.082 1.081-1.652 3.455-1.803 4.507-.751.3-2.614.991-4.056 1.352-1.442.36-3.605 2.553-4.507 3.605l-.901 3.605c-1.953-.15-6.58.27-9.464 3.155s-3.004 7.211-2.704 9.014z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#error_svg__d)",
  d: "M242.981 128.795c-11.537-.721-17.125-6.009-18.477-8.563l-2.253-59.941-4.507-13.971 27.04-14.422 3.155-2.704 4.506-2.254 5.859-.45c.451-.451 1.803-1.623 3.605-2.704 2.254-1.353 7.211-1.353 10.366 0s7.21 4.506 9.464 6.76c1.802 1.803 3.154 4.957 3.605 6.31l1.352 5.408 3.155 17.126.45 10.365-.45 8.113-2.254 11.718-4.056 10.365-4.056 7.662-9.013 10.366c-4.356 3.905-15.954 11.537-27.491 10.816"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M159.894 57.224s7.392 1.896 10.486 7.5 6.431 13.268 6.431 13.268l1.999 9.57 1.105 7.809.395 8.454-.866 10.282-2.018 7.405-3.537 6.075 17.792-9.705-5.296-14.981-2.413-14.328.701-14.317 1.769-7.712 3.749-6.798 3.671-2.512 14.438-7.876 28.682-15.646-3.421-5.296-2.941-3.678-2.366-2.022-3.037-1.175.442 4.766s-1.133 3.13-2.278 3.832c-1.144.703-2.105 1.406-3.527 1.502s-5.162-.8-5.162-.8-.26 3.467-.961 4.478c-.702 1.011-3.682 2.879-3.682 2.879l-4.018.183-1.23-.356-.211 4.371-2.518 3.37-3.25 1.29-3.402-.491-2.019-.578-.038 3.842s.077 2.62-1.74 3.784c-1.817 1.165-4.066 2.196-5.469 1.964-1.403-.23-6.085-2.801-6.085-2.801l-5.373-2.504s-3.701.096-4.412.577c-.711.483-10.217 5.662-10.217 5.662z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m195.756 57.214 4.71 1.849 4.912 5.363 3.528 6.402 2.489 6.422 2.528 8.02.923 7.598.596 6.96.297 6.847-1.181 7.991-1.817 6.586-3.133 5.439 29.22-15.26 4.855-11.67 1.172-8.607-.856-5.546-3.383-8.945-4.902-7.76-3.874-3.332-6.844-5.036-3.758-4.024-1.692-4.285v-2.541l1.884-3.948 2.663-1.907 3.815-1.184 4.115.423 1.509-3.64 2.768-3.426 4.614-1.011 4.816.404.576-3.668.856-1.763-2.788-.356-45.158 24.562z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M169.843 129.367c8.178-1.194 12.461-18.303 9.564-38.213s-11.875-35.083-20.054-33.889-12.461 18.302-9.564 38.213c2.897 19.91 11.875 35.083 20.054 33.889ZM205.041 129.367c8.178-1.194 12.46-18.303 9.564-38.213s-11.875-35.083-20.054-33.889-12.461 18.302-9.564 38.213c2.897 19.91 11.875 35.083 20.054 33.889ZM236.646 33.882c-2.72-5.738-5.979-9.917-9.324-11.755 0 0-1.471-.819-2.095-.53"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m171.552 128.867 20.138-10.986"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m193.007 57.694 40.092-21.876 9.401-5.131s2.028-1.262 4.672-.463"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M202.507 111.949c4.228-.617 6.443-9.46 4.946-19.752-1.498-10.293-6.139-18.136-10.368-17.518s-6.443 9.46-4.946 19.753c1.498 10.292 6.139 18.135 10.368 17.517M167.309 111.951c4.229-.617 6.443-9.46 4.946-19.752-1.498-10.293-6.139-18.136-10.368-17.518s-6.443 9.46-4.945 19.752c1.497 10.293 6.139 18.136 10.367 17.518"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m175.984 18.787.154-1.02s1.038-9.167 16.59-7.068c10.613 2.118 16.062 7.395 18.994 12.132 1.826 2.888 4.508 10.918.913 13.845-3.604 2.927-6.872 1.734-6.872 1.734l-1.212-.54"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M214.241 124.843s-1.875 21.894-7.71 31.783c-5.834 9.888-14.86 17.061-20.117 18.746-5.249 1.685-21.811 3.996-21.811 3.996s-14.774 1.213-14.774 8.733c0 5.44 10.026 5.324 14.774 5.18s30.538-1.011 30.538-1.011 8.219-.434 11.381-6.923c3.171-6.49 2.884 6.21 2.884 6.21l23.481-.433 9.737-26.825s6.239-15.559 6.239-26.612l3.614 26.025s30.893 2.272 45.524-5.969c-4.769-9.147-9.488-20.74-13.265-30.811l-2.846-9.041"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M206.204 157.26c-5.834 9.888-14.543 16.58-19.79 18.265-5.249 1.685-21.811 3.996-21.811 3.996s-14.774 1.213-14.774 8.732c0 5.44 10.026 5.325 14.774 5.181s30.538-1.012 30.538-1.012 8.219-.432 11.381-6.922c3.171-6.499 2.884 6.21 2.884 6.21l23.481-.433s7.402-20.345 8.758-24.245c-23.954-2.031-35.441-9.772-35.441-9.772"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M241.645 167.024c-4.777-.405-25.156-3.525-35.114-9.292M233.176 25.958c-.683-6.538 3.47-11.516 3.47-11.516 3.604-3.947 9.949-8.627 19.926-8.954 17.456-.568 24.395 8.694 26.27 15.742.144.549.259 1.078.336 1.589.192 1.165.221 2.205.144 3.139l.039 5.122"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M232.503 42.762c-.01-2.485 1.442-4.266 1.442-4.266s3.422-6.788 16.735-1.588 14.571 20.7 14.571 20.7"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M252.324 65.733s-1.259-15.5-14.572-20.7-16.735 1.589-16.735 1.589-1.451 1.79-1.441 4.265c0 0-.289 4.179 3.143 7.654 1.508 1.53 5.238 4.564 7.554 5.999 3.788 2.359 5.796 4.631 8.238 8.366 5.325 8.175 6.324 15.117 6.209 20.423-.153 6.72-5.892 18.101-5.892 18.101M245.73 34.49c-.01-2.483 1.442-4.266 1.442-4.266s3.421-6.787 16.734-1.588c13.313 5.2 14.572 20.701 14.572 20.701M206.531 129.049l32.297-17.629"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M249.805 12.604S248.392-.22 260.254 1.724c3.181.52 4.988 4.39 4.988 4.39"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M256.101 12.759s.874-14.683 11.919-9.888c2.585 1.126 4.316 5.257 4.316 5.257M209.713 38.013s-4.114-9.301-3.931-12.71c.135-2.503 1.557-4.332 3.931-4.592M200.101 46.41s-4.114-9.301-3.931-12.71c.134-2.503 1.557-4.332 3.931-4.593"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M159.365 57.272s-3.076-4.276-4.229-10.215c-1.154-5.942-1.164-7.877-.645-11.19.317-1.77 1.683-10.33 17.244-8.231 10.613 2.118 16.062 7.394 18.994 12.132 1.826 2.888 4.508 10.918.913 13.845-3.604 2.927-6.872 1.733-6.872 1.733s-2.442-1.252-7.662-4.178c-2.863-1.608-6.084-.626-6.084-.626l-14.658 8"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M188.701 54.94s-4.114-9.3-3.931-12.709c.134-2.503 1.557-4.332 3.931-4.592"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M187.393 10.842s1.039-9.166 16.591-7.067c10.612 2.118 16.062 7.395 18.994 12.132 1.826 2.889 4.508 10.919.913 13.845-3.595 2.928-6.873 1.733-6.873 1.733l-2.604-.74"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M220.969 31.08s-4.115-9.301-3.932-12.71c.135-2.503 1.558-4.333 3.932-4.593"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m166.266 27.316.26-1.155s1.038-9.166 16.591-7.067c10.611 2.118 16.061 7.394 18.992 12.131 1.827 2.89 4.509 10.919.914 13.845-3.605 2.928-6.872 1.734-6.872 1.734s-2.72-.722-3.105-.992"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M221.017 46.621s3.287 2.917 6.949 1.608c3.663-1.31 5.123-3.678 5.123-3.678M234.56 38.072s3.287 2.917 6.95 1.607c3.662-1.31 5.124-3.677 5.124-3.677M247.959 30.195s3.288 2.918 6.95 1.608c3.672-1.31 5.124-3.678 5.124-3.678"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M224.093 119.467s4.594 8.637 18.57 9.398 25.991-9.398 25.991-9.398 32.451-22.838 18.196-77.055c-.999-6.152-3.479-11.332-9.121-15.733-6.287-4.313-11.132-4.053-14.227-3.485-2.71.49-4.498 1.752-5.084 3.399"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M268.645 119.468s25.847 5.402 31.73-30.3c6.248-37.869-12.929-47.545-12.929-47.545"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M204.389 125.021c6.13-.895 9.03-15.842 6.478-33.384s-9.59-31.039-15.72-30.144-9.031 15.842-6.479 33.384 9.591 31.039 15.721 30.144ZM168.575 125.019c6.131-.895 9.032-15.842 6.479-33.384s-9.59-31.038-15.721-30.144c-6.13.895-9.03 15.842-6.478 33.384 2.552 17.544 9.59 31.039 15.72 30.144Z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F2F2F2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m192.642 59.658 48.753-30.56"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M144.395 141.516c-53.526 4.826-92.046 18.297-92.046 34.15 0 19.915 60.733 36.055 135.648 36.055 74.916 0 135.648-16.14 135.648-36.055 0-15.862-38.518-29.324-92.045-34.15"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M144.395 141.516c-53.526 4.826-92.046 18.297-92.046 34.15 0 19.915 60.733 36.055 135.648 36.055 74.916 0 135.648-16.14 135.648-36.055 0-15.862-38.518-29.324-92.045-34.15"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M187.997 195.946c52.792 0 95.589-10.508 95.589-23.471s-42.797-23.471-95.589-23.471-95.588 10.508-95.588 23.471 42.796 23.471 95.588 23.471"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M231.588 141.516c-13.684-1.235-28.353-1.905-43.602-1.905-15.25 0-29.918.67-43.603 1.905"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M231.588 141.516c-13.684-1.235-28.353-1.905-43.602-1.905-15.25 0-29.918.67-43.603 1.905M274.519 182.877c.887-1.221 1.361-2.487 1.361-3.778 0-11.852-39.345-21.46-87.88-21.46s-87.88 9.608-87.88 21.46c0 1.291.002 1.646.901 2.877"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M200.672 157.051s4.258 22.102-21.864 28.276c-12.485 1.449-20.537-2.575-24.814-5.799l-3.46-2.922L40.826 203.82l.623-4.76"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M200.672 157.051s4.258 22.102-21.864 28.276c-12.485 1.449-20.537-2.575-24.814-5.799l-3.46-2.922L40.826 203.82l.623-4.76"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m144.238 165.988-106.97 27.145 4.168 5.925 105.427-26.282s10.098 12.238 35.957 4.319c21.612-6.212 19.018-18.95 16.693-22.409-1.225-2.141-8.768-12.297-31.689-7.491-22.914 4.379-23.596 18.78-23.596 18.78z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "m36.71 192.803-.723 5.163 4.506 6.531"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m36.71 192.803-.723 5.163 4.506 6.531"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M200.672 157.051s4.258 22.102-21.864 28.276c-12.485 1.449-20.537-2.575-24.814-5.799l-3.46-2.922L40.826 203.82l.623-4.76"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M200.672 157.051s4.258 22.102-21.864 28.276c-12.485 1.449-20.537-2.575-24.814-5.799l-3.46-2.922L40.826 203.82l.623-4.76"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m144.238 165.988-106.97 27.145 4.168 5.925 105.427-26.282s10.098 12.238 35.957 4.319c21.612-6.212 19.018-18.95 16.693-22.409-1.225-2.141-8.768-12.297-31.689-7.491-22.914 4.379-23.596 18.78-23.596 18.78z"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#error_svg__e)",
  d: "m36.19 198.033.584-4.469c34.502-5.491 104.345-18.726 107.705-27.741 4.199-11.269 8.804-15.212 25.204-18.978s26.482 2.551 29.862 7.993c2.703 4.352 1.189 10.609.094 13.193-1.089 4.857-6.703 15.123-20.444 17.327s-24.661-4.889-28.404-8.711L40.017 203.533z"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m36.711 192.803-.723 5.163 4.505 6.531M200.672 157.051s4.258 22.102-21.864 28.276c-12.485 1.449-20.537-2.575-24.814-5.799l-3.46-2.922L40.826 203.82l.623-4.76"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m144.238 165.988-106.97 27.145 4.168 5.925 105.427-26.282s10.098 12.238 35.957 4.319c21.612-6.212 19.018-18.95 16.693-22.409-1.225-2.141-8.768-12.297-31.689-7.491-22.914 4.379-23.596 18.78-23.596 18.78z"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M175.703 179.683a6.74 6.74 0 0 1-1.674-4.451 6.775 6.775 0 0 1 6.782-6.777c3.749 0 7.109 3.031 7.109 6.777"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M175.703 179.683a6.74 6.74 0 0 1-1.674-4.451 6.775 6.775 0 0 1 6.782-6.777c3.749 0 7.109 3.031 7.109 6.777"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "error_svg__a",
  x1: 258.304,
  x2: 251.543,
  y1: 124.739,
  y2: 167.554,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#054BA2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error_svg__b",
  x1: 285.614,
  x2: 285.614,
  y1: 41.813,
  y2: 119.905,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002B94"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#1960B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.639,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error_svg__c",
  x1: 162.312,
  x2: 187.099,
  y1: 26.489,
  y2: 44.966,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAC292"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error_svg__d",
  x1: 274.528,
  x2: 265.965,
  y1: 42.264,
  y2: 116.627,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2F2F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.406,
  stopColor: "#F1E0C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.969,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error_svg__e",
  x1: 193.738,
  x2: 29.693,
  y1: 143.625,
  y2: 219.905,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3F77BC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#F2F2F2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.766,
  stopColor: "#F2F2F2",
  stopOpacity: 0.612
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2D69B4"
})))));
export default SvgError;